export default __webpack_public_path__ + "media/images/gps-b4152839f8cc99e9831d52edab22f4a4.svg";